export default {
  lastSeen: null,
  notifications: [],
}
